var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-btn"},[_c('span',{staticClass:"go-back"},[_c('v-btn',{attrs:{"depressed":"","fab":""},on:{"click":function($event){return _vm.goBack($event)}}},[_c('img',{attrs:{"src":require("../assets/go-back-arrow.png"),"alt":"go-back"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }